import React from 'react';
import { connect } from "react-redux";
import { LinkText, Typography } from "../../ecosystem";

const LinkRecord = ({
    to,
    removeBSWPharmacy
}) => {

    return (
        <div className="proxy-home-link-record-msg">
            <Typography type="body-01">
                You can link your {removeBSWPharmacy ? 'medical' : ""} record <LinkText to={to}>here.</LinkText>
            </Typography>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false
    };
};
export default connect(mapStateToProps, null)(LinkRecord);